import { useState, useRef } from "react";
import { collection, doc, addDoc, setDoc, deleteDoc } from 'firebase/firestore';

const EditPlainDish = (props) => {
    
    const [name, setName] = useState(props.new?'':props.menu.name);
    const [price, setPrice] = useState(props.new?'':props.menu.price);
    const [description, setDescription] = useState(props.new ? '':props.menu.description);

    const save = async () => {
        let updatePack = {
            name: name,
            description: description,
            price: parseFloat(price)
        };

        if(props.new){
            if(name.trim() === ""){
                window.alert("Debes colocar un nombre");
                return;
            }else if(price.toString().trim() === "" || parseFloat(price) <= 0){
                window.alert("Debes colocar un precio valido.");
                return;
            }else if(description.trim() === ""){
                window.alert("Debes colocar una descripcion");
                return;
            }else{
                let newDishList = props.menuList.slice();
                    newDishList[props.menuPos].dishes.push(updatePack);

                const menuRef = doc(props.eDB, `Restaurants/${props.resID}/Menu/${props.menuID}`);
                setDoc(menuRef, newDishList[props.menuPos], {merge: true})
                .then((result) => {
                    console.log("Values applied to eDB");
                });
                props.setMenuList(newDishList);
                setTimeout(() => props.setCurrent(newDishList[props.menuPos]), 10);
                props.close();
            }
        }else if(props.delete){
            let newDishList = props.menuList.slice();
                newDishList[props.menuPos].dishes = props.menuList[props.menuPos].dishes.filter((dish) => {
                    return dish !== props.menu;
                });

            const menuRef = doc(props.eDB, `Restaurants/${props.resID}/Menu/${props.menuID}`);
            setDoc(menuRef, newDishList[props.menuPos], {merge: true})
            .then((result) => {
                console.log("Values applied to eDB");
            });
            props.setMenuList(newDishList);
            setTimeout(() => props.setCurrent(newDishList[props.menuPos]), 10);
            props.close();
        }else{
            //Update doc values
            if(compareDish(props.menu, updatePack)){
                console.log("P: ", price);
                if(name.trim() === ""){
                    window.alert("Debes colocar un nombre");
                    return;
                }else if(price.toString().trim() == "" || parseFloat(price) <= 0){
                    window.alert("Debes colocar un precio valido.");
                    return;
                }else if(description.trim() === ""){
                    window.alert("Debes colocar una descripcion");
                    return;
                }else{
                    const dishPos = props.menuList[props.menuPos].dishes.indexOf(props.menu);
                    let newDishList = props.menuList.slice();

                    newDishList[props.menuPos].dishes[dishPos] = updatePack;

                    const menuRef = doc(props.eDB, `Restaurants/${props.resID}/Menu/${props.menuID}`);
                    setDoc(menuRef, newDishList[props.menuPos], {merge: true})
                    .then((result) => {
                        console.log("Values applied to eDB");
                    });
                    props.setMenuList(newDishList);
                    setTimeout(() => props.setCurrent(newDishList[props.menuPos]), 10);
                }
            }

            props.close();
        }
    }

    const compareDish = (originalDish, newDish) => {
        if(originalDish.name !== newDish.name) return true;
        if(originalDish.description !== newDish.description) return true;
        if(originalDish.price !== newDish.price) return true;
        return false;
    }

    return (
        <>
        <div style={{position: 'relative'}}>
            <div className="mt-2">
                Nombre: <input type='text' value={name} onChange={(e) => setName(e.target.value)} disabled={props.delete}/>
            </div>
            <div className="mt-1">
                Precio: <input type='text' value={price} onChange={(e) => setPrice(e.target.value)} disabled={props.delete}/>
            </div>
            <div className="mt-1">
                Descripcion: <br/><textarea style={{width: '100%', minHeight: '60px'}} onChange={(e) => setDescription(e.target.value)} defaultValue={description} disabled={props.delete}></textarea>
            </div>

            <div className="mt-2">
                <button className={props.delete? 'm-auto btn btn-cancel':'m-auto btn btn-accept'} onClick={save}>{props.delete?'Borrar':'Guardar'}</button>
            </div>
        </div>
        </>
    );
}

export default EditPlainDish;